// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    font-size: 24px;

    overflow-wrap: break-word;
    word-wrap: break-word;
    max-width: 100%;
}

html, body {
    height: 100%;
}

body {
    background-color: #ebdbb2;
    display: flex;

    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    min-height: 100vh;
    border: 3px solid #282828;
}

header {
    background-color: #83a598; 
    border-top: 3px solid #282828;
   
    width: 100%;
    padding: 0.5em 0; 
}

.list-add-btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 0px 0px 10px 0px;
}

.list-add-btn {
    position: relative;
    display: block;
    
    width: 100%;
    padding: 10px 16px;
    background-color: #fe8019;
    color: #282828;
    font-weight: 800;
    font-size: xx-large;
    text-transform: uppercase;

    border-radius: 6px;
    border: 3px solid #282828;
    box-shadow: 4px 4px #282828;
    cursor: pointer;
    text-align: center
}

.list-add-btn:active {
    transform: translateY(3px) translateX(3px);
    box-shadow: 1px 1px #282828;
}

nav {
    display: flex;
    gap: 3em;
    padding: 0 1.2em;
    flex-direction: row;
    justify-content: start;
    align-items: center;
}

#content {
    flex: 1;
    width: 100vw;
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding: 0em;
    box-sizing: border-box;
}

body > div > div {
    border: 3px solid #282828;
    width: 20em;
    height: 20em;
    display: flex;
    flex-direction: column;
    align-items: center;
    /*padding: 2em 0 0 0;*/
    margin-bottom: 0em;
}

.popup-div {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.list-window, .task-window {
    background: #f9f5d7;
    width: 20rem;
    height: 20em;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 3px solid #282828;    
    border-top: none;
    border-radius: 9px;
    overflow: hidden;
}

.list-window-header, .task-window-header {
    background-color: #83a598;
    border: 3px solid #282828;
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0.2em 1em; 
}

.close-btn-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    padding: 0px 0px 10px 0px
}


.close-btn {
    position: relative;
    display: block;
    
    width: 95%;
    padding: 10px 16px;
    background-color: #fe8019;
    color: #282828;
    font-weight: 800;
    font-size: xx-large;
    text-transform: uppercase;

    border-radius: 6px;
    box-shadow: 4px 4px #282828;
    text-align: center;

    background: none;
    border: 3px solid #282828;
    width: 40px;
    height: 40px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.close-btn:active {
    transform: translateY(3px) translateX(3px);
    box-shadow: 1px 1px #282828;
}

.todo-form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 0.5em;
    padding: 1em;
    width: 100%;
    flex: 1;
    box-sizing: border-box;
}

.todo-form label {
    display: flex;
    flex-direction: column;
    gap: 0.3em;
    font-size: 0.8em;
}

.todo-form input,
.todo-form textarea,
.todo-form select {
    font-size: 0.9em;
    padding: 0em;
    border: 2px solid #282828;
    background: #f9f5d7;
}

.submit-button, .cancel-button, .delete-button {
    background: #282828;
    color: #f9f5d7;
    
    border: 3px solid #282828;
    height: 40px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
}

.list-window-footer, .task-window-footer {
    color: #f9f5d7;
    padding: 0.3em;
    width: 100%;

    display: flex;
    justify-content: space-evenly;
    align-items: center;
}



.todo-display {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1em;
    justify-content: flex-start;
    align-items: start;
    padding: 1em;
    box-sizing: border-box;
    overflow: auto;
}

.todo-item {
    border: 3px solid #282828;
    padding: 1em;
    border-radius: 6px;
    background: #f9f5d7;
    font-size: 24px;

    width: 400px;
    height: 600px;
    flex: 0 0 auto;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.todo-content, .task-content {
    border-bottom: 3px solid #282828;
}

.todo-content > p, .task-content > p {
    font-size: 20px;
}


.task-item {
    border: 3px solid #282828;
    padding: 1em;
    font-size: 12px;
}



.priority-low { border-left: 4px solid #b8bb26; }
.priority-medium { border-left: 4px solid #fe8019; }
.priority-high { border-left: 4px solid #fb4934; }

.todo-item-footer, .task-item-footer {
    display: flex;
    flex-direction: row;
    gap: 0.5em;
    justify-content: center;
    align-items: center;
}

.todo-btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 0px 0px 10px 0px;
}

.todo-item-footer > div > button, .task-item-footer > div > button {
    position: relative;
    display: block;
    
    width: 100%;
    padding: 10px 16px;
    font-weight: 800;
    font-size: 24px;
    text-transform: uppercase;

    border-radius: 6px;
    border: 3px solid #282828;
    box-shadow: 4px 4px #282828;
    text-align: center;
    
    background: #fe8019;
    color: #282828;
    padding: 0.3em 0.6em;
    cursor: pointer;
}

.task-item-footer > div > button {
    font-size: 20px;
}

.todo-item-footer > div > button:active, .task-item-footer > div > button:active {
    transform: translateY(3px) translateX(3px);
    box-shadow: 1px 1px #282828;
}

.footer {
    background-color: #282828;
    color: #f9f5d7;
    text-align: center;
    padding: 1.5em;
    position: relative;
    width: 100%;
    bottom: 0px;
}

.credit {
    color: inherit;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,8BAA8B;IAC9B,eAAe;;IAEf,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,aAAa;;IAEb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;;IAE7B,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;;IAEd,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;;IAEzB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,eAAe;IACf;AACJ;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR;AACJ;;;AAGA;IACI,kBAAkB;IAClB,cAAc;;IAEd,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;;IAEzB,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB;;IAElB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,WAAW;IACX,OAAO;IACP,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,gBAAgB;AACpB;;AAEA;;;IAGI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;;IAEd,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,WAAW;;IAEX,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;;;AAIA;IACI,OAAO;IACP,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;;IAEf,YAAY;IACZ,aAAa;IACb,cAAc;;IAEd,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;;;AAIA,gBAAgB,8BAA8B,EAAE;AAChD,mBAAmB,8BAA8B,EAAE;AACnD,iBAAiB,8BAA8B,EAAE;;AAEjD;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;;IAEd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;;IAEzB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;;IAElB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB","sourcesContent":["* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    font-family: Arial, sans-serif;\n    font-size: 24px;\n\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    max-width: 100%;\n}\n\nhtml, body {\n    height: 100%;\n}\n\nbody {\n    background-color: #ebdbb2;\n    display: flex;\n\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 100vh;\n    border: 3px solid #282828;\n}\n\nheader {\n    background-color: #83a598; \n    border-top: 3px solid #282828;\n   \n    width: 100%;\n    padding: 0.5em 0; \n}\n\n.list-add-btn-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n    padding: 0px 0px 10px 0px;\n}\n\n.list-add-btn {\n    position: relative;\n    display: block;\n    \n    width: 100%;\n    padding: 10px 16px;\n    background-color: #fe8019;\n    color: #282828;\n    font-weight: 800;\n    font-size: xx-large;\n    text-transform: uppercase;\n\n    border-radius: 6px;\n    border: 3px solid #282828;\n    box-shadow: 4px 4px #282828;\n    cursor: pointer;\n    text-align: center\n}\n\n.list-add-btn:active {\n    transform: translateY(3px) translateX(3px);\n    box-shadow: 1px 1px #282828;\n}\n\nnav {\n    display: flex;\n    gap: 3em;\n    padding: 0 1.2em;\n    flex-direction: row;\n    justify-content: start;\n    align-items: center;\n}\n\n#content {\n    flex: 1;\n    width: 100vw;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    padding: 0em;\n    box-sizing: border-box;\n}\n\nbody > div > div {\n    border: 3px solid #282828;\n    width: 20em;\n    height: 20em;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    /*padding: 2em 0 0 0;*/\n    margin-bottom: 0em;\n}\n\n.popup-div {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    border: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.list-window, .task-window {\n    background: #f9f5d7;\n    width: 20rem;\n    height: 20em;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    border: 3px solid #282828;    \n    border-top: none;\n    border-radius: 9px;\n    overflow: hidden;\n}\n\n.list-window-header, .task-window-header {\n    background-color: #83a598;\n    border: 3px solid #282828;\n    border-radius: 6px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 0.2em 1em; \n}\n\n.close-btn-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 2px;\n    padding: 0px 0px 10px 0px\n}\n\n\n.close-btn {\n    position: relative;\n    display: block;\n    \n    width: 95%;\n    padding: 10px 16px;\n    background-color: #fe8019;\n    color: #282828;\n    font-weight: 800;\n    font-size: xx-large;\n    text-transform: uppercase;\n\n    border-radius: 6px;\n    box-shadow: 4px 4px #282828;\n    text-align: center;\n\n    background: none;\n    border: 3px solid #282828;\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.close-btn:active {\n    transform: translateY(3px) translateX(3px);\n    box-shadow: 1px 1px #282828;\n}\n\n.todo-form {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 0.5em;\n    padding: 1em;\n    width: 100%;\n    flex: 1;\n    box-sizing: border-box;\n}\n\n.todo-form label {\n    display: flex;\n    flex-direction: column;\n    gap: 0.3em;\n    font-size: 0.8em;\n}\n\n.todo-form input,\n.todo-form textarea,\n.todo-form select {\n    font-size: 0.9em;\n    padding: 0em;\n    border: 2px solid #282828;\n    background: #f9f5d7;\n}\n\n.submit-button, .cancel-button, .delete-button {\n    background: #282828;\n    color: #f9f5d7;\n    \n    border: 3px solid #282828;\n    height: 40px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 5px;\n}\n\n.list-window-footer, .task-window-footer {\n    color: #f9f5d7;\n    padding: 0.3em;\n    width: 100%;\n\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n}\n\n\n\n.todo-display {\n    flex: 1;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 1em;\n    justify-content: flex-start;\n    align-items: start;\n    padding: 1em;\n    box-sizing: border-box;\n    overflow: auto;\n}\n\n.todo-item {\n    border: 3px solid #282828;\n    padding: 1em;\n    border-radius: 6px;\n    background: #f9f5d7;\n    font-size: 24px;\n\n    width: 400px;\n    height: 600px;\n    flex: 0 0 auto;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.todo-content, .task-content {\n    border-bottom: 3px solid #282828;\n}\n\n.todo-content > p, .task-content > p {\n    font-size: 20px;\n}\n\n\n.task-item {\n    border: 3px solid #282828;\n    padding: 1em;\n    font-size: 12px;\n}\n\n\n\n.priority-low { border-left: 4px solid #b8bb26; }\n.priority-medium { border-left: 4px solid #fe8019; }\n.priority-high { border-left: 4px solid #fb4934; }\n\n.todo-item-footer, .task-item-footer {\n    display: flex;\n    flex-direction: row;\n    gap: 0.5em;\n    justify-content: center;\n    align-items: center;\n}\n\n.todo-btn-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n    padding: 0px 0px 10px 0px;\n}\n\n.todo-item-footer > div > button, .task-item-footer > div > button {\n    position: relative;\n    display: block;\n    \n    width: 100%;\n    padding: 10px 16px;\n    font-weight: 800;\n    font-size: 24px;\n    text-transform: uppercase;\n\n    border-radius: 6px;\n    border: 3px solid #282828;\n    box-shadow: 4px 4px #282828;\n    text-align: center;\n    \n    background: #fe8019;\n    color: #282828;\n    padding: 0.3em 0.6em;\n    cursor: pointer;\n}\n\n.task-item-footer > div > button {\n    font-size: 20px;\n}\n\n.todo-item-footer > div > button:active, .task-item-footer > div > button:active {\n    transform: translateY(3px) translateX(3px);\n    box-shadow: 1px 1px #282828;\n}\n\n.footer {\n    background-color: #282828;\n    color: #f9f5d7;\n    text-align: center;\n    padding: 1.5em;\n    position: relative;\n    width: 100%;\n    bottom: 0px;\n}\n\n.credit {\n    color: inherit;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
